// extracted by mini-css-extract-plugin
export default {"container":"TOF6dxJhKUqhMpKxQPoG","inner":"V9ssvVgAYD6Nhmuq8hQw"};